'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext } from 'react';
import { useAutoPreviewObserver } from '@/hooks/useAutoPreviewObserver';
import { AutoPreviewContextValue } from '@/types/auto-preview';
const CenterLineContext = createContext<AutoPreviewContextValue | null>(null);
export function useCenterLine() {
  return useContext(CenterLineContext);
}
export function CenterLineProvider(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  const value = useAutoPreviewObserver();
  let t1;
  if ($[0] !== children || $[1] !== value) {
    t1 = <CenterLineContext.Provider value={value}>{children}</CenterLineContext.Provider>;
    $[0] = children;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}